/** Maximum text answer length stored in waiver submission answers. */
export const WAIVER_TEXT_ANSWER_MAX_LENGTH = 2500;

/**
 * Container the public waiver app renders a form in.
 * Border and rounding from md viewport; print/PDF drops card chrome.
 */
export const WAIVER_FORM_CONTAINER_CLASS = 'mx-auto w-full max-w-3xl bg-default p-4 md:rounded-lg md:border md:border-default md:p-8 print:border-0 print:rounded-none print:p-0';

/** Vertical inset around the form card on elevated page backgrounds. */
export const WAIVER_FORM_PAGE_INSET_CLASS = 'md:py-4 print:py-0';

/** Establishes container query context on the Partner Portal preview panel. */
export const WAIVER_FORM_PREVIEW_ROOT_CLASS = '@container';

/** UCard body: elevated background when the preview panel is lg+ wide. */
export const WAIVER_FORM_PREVIEW_CARD_BODY_CLASS = 'p-0 @lg:bg-elevated';

/** Inset padding when the preview column is lg+ wide. */
export const WAIVER_FORM_PREVIEW_INSET_CLASS = '@lg:p-4';

/**
 * Partner Portal preview form card: always bg-default; border/rounding when the preview
 * column is lg+ wide so elevated background is visible beside the centered max-w-3xl card.
 */
export const WAIVER_FORM_PREVIEW_CONTAINER_CLASS = 'mx-auto w-full max-w-3xl bg-default p-4 @lg:rounded-lg @lg:border @lg:border-default @lg:p-8';
